import React from 'react';
import { Sparkles } from 'lucide-react';
import { PageContent, PageHeader } from '@/components/layout/page-header';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';

/**
 * Reusable placeholder for routes that exist in navigation
 * but haven't been built yet. Keeps the nav functional
 * and signals "coming soon" without breaking the app.
 */
export function PlaceholderPage({ title, description, phase = 'Coming soon' }) {
  return (
    <>
      <PageHeader
        title={title}
        description={description}
        action={
          <Badge variant="soft" className="gap-1.5 py-1 px-2.5">
            <Sparkles className="size-3" />
            {phase}
          </Badge>
        }
      />
      <PageContent>
        <Card className="border-dashed">
          <CardContent className="flex min-h-[400px] flex-col items-center justify-center gap-3 p-12 text-center">
            <div className="flex size-12 items-center justify-center rounded-full bg-primary-soft">
              <Sparkles className="size-5 text-primary" />
            </div>
            <h3 className="text-base font-semibold">{title} is on the way</h3>
            <p className="max-w-md text-sm text-muted-foreground">
              {description ||
                "This module is part of the upcoming roadmap. It's wired into navigation so the structure is locked in - the screen itself ships in a later phase."}
            </p>
          </CardContent>
        </Card>
      </PageContent>
    </>
  );
}
